import { SearchInput, styled } from 'canoe';
import React from 'react';

const ComponentsSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface ComponentsSearchFilterProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filter?: string;
  onClear: () => void;
}

export class ComponentsSearchFilter extends React.PureComponent<ComponentsSearchFilterProps> {
  render() {
    const { onChange, filter, onClear } = this.props;
    return (
      <ComponentsSearchWrapper>
        <SearchInput
          scale="small"
          onChange={onChange}
          value={filter || ''}
          placeholder="Search Components"
          onClear={onClear}
        />
      </ComponentsSearchWrapper>
    );
  }
}
